module.exports = __webpack_public_path__ + "img/配置管理_xz.b3c17558.jpg";